// Mood display helpers (W36.0, spec §2.3).
//
// Split out of `MoodPickerSheet.tsx` because that file exports components only —
// ESLint's `react-refresh/only-export-components` rule requires pure logic to
// live elsewhere, and more importantly the pairing contract below is worth
// reading on its own.
//
// **Nothing here invents a value.** Both helpers resolve a locked diary mood
// code back to its category and then read the label / emoji from
// `lib/diary/mood.ts`. The picker writes `mood_{category}_3`, so a code from any
// other level resolves to "" rather than to a plausible-looking wrong answer —
// a silent mislabel is worse than an empty pill.

import {
  EMOJI_FOR_CATEGORY,
  MOOD_CATEGORIES,
  MOOD_CATEGORY_LABEL_ZH,
  moodCode,
  type MoodCategory,
} from "@/lib/diary/mood";

/** The one level the dashboard check-in writes (spec §2.3 R4.1). */
export const CHECKIN_LEVEL = 3 as const;

export function categoryForCheckin(
  code: string | null | undefined,
): MoodCategory | null {
  if (!code) return null;
  return (
    MOOD_CATEGORIES.find((c) => code === moodCode(c, CHECKIN_LEVEL)) ?? null
  );
}

export function moodEmojiFor(code: string | null | undefined): string {
  const category = categoryForCheckin(code);
  return category ? EMOJI_FOR_CATEGORY[category] : "";
}

export function moodLabelFor(code: string | null | undefined): string {
  const category = categoryForCheckin(code);
  return category ? MOOD_CATEGORY_LABEL_ZH[category] : "";
}
